import React from 'react'
import { MODEL_COLOR } from '../../model/ModelColor';

const Counter = ({ title, _substract, _add, counter, limit }) => { 
    return (
        <div className='text-center mt-3'>

            {/* CARTE FIDELITE */}
            <div className='d-inline-flex'>

                {/* TITLE */} 
                <span className='my-2 me-2'>{title}</span>

                {/* SUBSTRACT WEEK */}
                <div 
                    onClick={_substract}
                    style={{ 
                        cursor:'pointer',
                        height:'2rem', 
                        width:'2rem', 
                        fontSize:20,
                        backgroundColor:'lightgrey', 
                        verticalAlign:'middle',
                        borderTopLeftRadius:'20%', 
                        borderBottomLeftRadius:'20%',
                        lineHeight:'2rem' 
                    }}>-
                </div>

                {/* SHOW WEEK */}
                <div 
                    style={{ 
                        height:'2rem', 
                        width:'2rem', 
                        fontSize:20,
                        borderTop:'solid', 
                        verticalAlign:'middle',
                        borderBottom:'solid', 
                        borderColor:'lightgrey',
                        lineHeight:'2rem',
                        backgroundColor: limit ? MODEL_COLOR.blueApply : ''
                    }}>{counter}
                </div> 

                {/* ADD WEEK */}
                <div 
                    onClick={_add}
                    style={{ 
                        cursor:'pointer',
                        height:'2rem', 
                        width:'2rem', 
                        fontSize:20,
                        backgroundColor:'lightgrey', 
                        verticalAlign:'middle',
                        borderTopRightRadius:'20%', 
                        borderBottomRightRadius:'20%',
                        lineHeight:'2rem' 
                    }}>+
                </div>

            </div>
        </div>
    )
}

export default Counter

